import React, { useState, useRef } from 'react';
import { Map } from '../components/svg';
import MapModal from "../mapModal/index";

import './style.css';

function MiniMap(props) {
  const [ showModal, setShowModal ] = useState(false);
  const childRef = useRef();

  const changeScene=(i)=>{
    props.changeScene(i)
  }

  const closeModal=()=>{
    setShowModal(!showModal)
    childRef.current.closeModals()
  }

  return (
    <div className="mini-map-wrapper">
      <Map currentScene = {props.currentScene} show={showModal} onClick={closeModal}/>
        <div className={`map-modal ${showModal ? 'fadeIn' : 'fadeOut'}`}>
        <MapModal ref={childRef} closeModal = {() => setShowModal(false)} changeScene={changeScene} openInfoSpot={props.openInfoSpot}/>
      </div>
    </div>
  );
}

export default MiniMap;
